import { Button } from 'antd';
import styled from 'styled-components';

const HollowButton = styled(Button)<{ inverted?: boolean }>`
    background-color: ${({ inverted }) => (inverted ? '#161616' : 'transparent')};
    border-color: #161616;
    padding: ${({ shape }) => (shape === 'circle' ? '0 0.9rem' : '0 0.9em')};
    border-radius: ${({ shape }) => (shape === 'circle' ? '50%' : '4px')};

    color: ${({ inverted }) => (inverted ? 'white' : '#161616')};
    font-weight: 400;

    transition: 100ms;

    :focus {
        background-color: ${({ inverted }) => (inverted ? '#161616' : 'transparent')};
        border-color: #161616;
        color: ${({ inverted }) => (inverted ? 'white' : '#161616')};
    }

    :hover {
        background-color: ${({ inverted }) => (inverted ? '#262626' : '#161616')};
        border-color: #161616;
        color: white;
    }
`;

export default HollowButton;
